import React, { useState, useEffect, useRef } from 'react'
import { motion, useMotionValue, useSpring } from 'framer-motion'
import ShowMoreButton from './button'

interface Props {
  children: React.ReactNode
  className?: string
  defaultHeight?: number
}

const Showmore = ({ children, className = '', defaultHeight = 0 }: Props) => {
  const [ isShowmore, setShowmore ] = useState(false)
  const [ height, setHeight ] = useState(defaultHeight)
  const childRef = useRef<HTMLDivElement | null>(null)

  const motionH = useMotionValue(defaultHeight)
  const springH = useSpring(motionH, { stiffness: 300, damping: 30 })

  const onResize = () => setHeight(childRef.current.offsetHeight)

  useEffect(() => {
    window.addEventListener('resize', onResize)
    onResize()
    return () => window.removeEventListener('resize', onResize)
  })

  return (
    <>
      <motion.div
        className={className}
        style={{ height: springH, overflow: 'hidden' }}
        transition={{ ease: 'easeOut', duration: 0.3 }}
      >
        <div ref={childRef}>{children}</div>
      </motion.div>
      {height > defaultHeight && (
        <ShowMoreButton
          more={isShowmore}
          onChange={(more) => {
            setShowmore(more)
            motionH.set(more ? height : defaultHeight)
          }}
        />
      )}
    </>
  )
}

export default Showmore
